__turbopack_context__.v({
  "balance": "MobileCards-module-scss-module__jK6UCq__balance",
  "card": "MobileCards-module-scss-module__jK6UCq__card",
  "cardActions": "MobileCards-module-scss-module__jK6UCq__cardActions",
  "cardData": "MobileCards-module-scss-module__jK6UCq__cardData",
  "cardImg": "MobileCards-module-scss-module__jK6UCq__cardImg",
  "cardImgIcon": "MobileCards-module-scss-module__jK6UCq__cardImgIcon",
  "cardImgSoloIcon": "MobileCards-module-scss-module__jK6UCq__cardImgSoloIcon",
  "cardName": "MobileCards-module-scss-module__jK6UCq__cardName",
  "cardNumber": "MobileCards-module-scss-module__jK6UCq__cardNumber",
  "cardOpenButton": "MobileCards-module-scss-module__jK6UCq__cardOpenButton",
  "cardStepsText": "MobileCards-module-scss-module__jK6UCq__cardStepsText",
  "cardStepsText2": "MobileCards-module-scss-module__jK6UCq__cardStepsText2",
  "cardToken": "MobileCards-module-scss-module__jK6UCq__cardToken",
  "issueCard": "MobileCards-module-scss-module__jK6UCq__issueCard",
  "mtop": "MobileCards-module-scss-module__jK6UCq__mtop",
  "root": "MobileCards-module-scss-module__jK6UCq__root",
});
